export const version = "abstract-signer/5.4.1";
//# sourceMappingURL=_version.js.map